<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script>
import { oneOf } from "@/utils/assist";

const prefixCls = "gy-steps";
export default {
  name: "GySteps",
  props: {
    current: {
      type: Number,
      default: 0,
    },
    direction: {
      validator(value) {
        return oneOf(value, ["horizontal", "vertical"]);
      },
      default: "horizontal",
    },
    status: {
      validator(value) {
        return oneOf(value, ["wait", "process", "finish", "error"]);
      },
      default: "process",
    },
  },
  computed: {
    classes() {
      return [`${prefixCls}`, `${prefixCls}-${this.direction}`];
    },
  },
  methods: {
    updateChildProps(isInit) {
      // 1.获取子元素个数
      const total = this.$children.length;
      // 2.遍历子元素
      this.$children.forEach((child, index) => {
        child.stepNumber = index + 1;
        // 3.设置子元素总数
        if (this.direction === "horizontal") {
          child.total = total;
        }

        // 4.根据当前current状态，设置子元素各自的状态
        if (!(isInit && child.currentStatus)) {
          if (index === this.current) {
            if (this.status !== "error") {
              child.currentStatus = "process";
            }
          } else if (index < this.current) {
            child.currentStatus = "finish";
          } else {
            child.currentStatus = "wait";
          }
        }

        if (child.currentStatus !== "error" && index !== 0) {
          this.$children[index - 1].nextError = false;
        }
      });
    },
    updateCurrent(isInit) {
      if (this.current < 0 || this.current >= this.$children.length) {
        return;
      }
      if (isInit) {
        const currentStatus = this.$children[this.current].currentStatus;
        if (!currentStatus) {
          this.$children[this.current].currentStatus = this.status;
        }
      } else {
        this.$children[this.current].currentStatus = this.status;
      }
    },
    updateSteps() {
      this.updateChildProps(true);
      this.updateCurrent(true);
    },
  },
  mounted() {
    this.updateSteps();
  },
  watch: {
    current() {
      this.updateChildProps();
    },
    status() {
      this.updateCurrent();
    },
  },
};
</script>

<style lang="less">
.gy-steps {
  display: flex;
  width: 100%;
}
</style>
